import { Action } from "../Actions/actionRepository";
import { Trigger } from "./triggerRepository";

export interface DelayTriggerParam {
    timeToAction: number;
}

export class DelayTrigger implements Trigger {
    params: DelayTriggerParam;

    constructor(params: DelayTriggerParam) {
        this.params = params;
    }

    // timeout: number;
    // hasRun: boolean;
    init = (action: Action) => {
        let actualTime = this.params.timeToAction * 1000;
        setTimeout(() => {
            action.execute();
        }, actualTime);
    };
}
